import { Object3D, Euler, Vector3, Matrix4 } from "three";
import { BasePanel } from "./BasePanel.js";
import Util from "../utils/utils.js";
import { TerrainBrush } from "../utils/TerrainBrush.js";

const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";
const sliderBgPath = "/assets/vrUI/EditPanel_Material/sliderBg1.png";
const sliderHandlePath = "/assets/vrUI/EditPanel_Material/sliderHandle.png";

export class EditPanel_Terrain extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
    this.terrainBrush = null;
    this.isModifying = false;
    console.log(this._visible);
  }

  init() {}

  async initPanel(parent) {
    this.parent = parent;

    this.width = 2.175;
    this.height = 0.7;
    this.container = this.uilib.createContainer({
      opacity: 0,
      width: this.width,
      height: this.height,
      radius: 0,
      dragable: false,
    });
    this.parent.add(this.container);
    this.uiElements.push(this.container);
    this.container.visible = this._visible;

    // 创建地形工具UI
    await this._createTerrainToolUI();

    if (!this._visible) {
      this.closePanel();
    }

  }

  async _createTerrainToolUI() {
    const btn_normal = await this.manager.loadManager.loadTexture(
      btn_normalPath
    );
    const btn_hover = await this.manager.loadManager.loadTexture(btn_hoverPath);
    const btn_click = await this.manager.loadManager.loadTexture(btn_clickPath);
    const sliderBg = await this.manager.loadManager.loadTexture(sliderBgPath);
    const sliderHandle = await this.manager.loadManager.loadTexture(sliderHandlePath);


    // 创建笔刷半径滑块
    const radiusSlider = this.uilib.createSlider({
      bgMap: sliderBg,
      handleMap: sliderHandle,
      color:0xffffff,
      handleColor:0xffffff,
      width: 0.8,
      height: 0.05,
    });
    radiusSlider.addOnValueChangeEvent((value) => {
      this.terrainBrush.setRadius(value * 10);
    })
    radiusSlider.position.set(-0.5, this.height / 2 - 0.1, 0.001);
    this.container.add(radiusSlider);

    // 笔刷半径标签和文本
    const radiusLabel = this.uilib.createText({
      text: "笔刷半径",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.035,
    });
    radiusLabel.position.set(-1.0, this.height / 2 - 0.1, 0.001);
    this.container.add(radiusLabel);


    // 创建笔刷强度滑块
    const strengthSlider = this.uilib.createSlider({
      bgMap: sliderBg,
      handleMap: sliderHandle,
      color:0xffffff,
      handleColor:0xffffff,
      width: 0.8,
      height: 0.05,
    });
    strengthSlider.addOnValueChangeEvent((value) => {
      this.terrainBrush.setStrength(value * 2);
    })
    strengthSlider.position.set(-0.5, this.height / 2 - 0.28, 0.001);
    this.container.add(strengthSlider);

    // 笔刷强度文本
    // 笔刷强度标签和文本
    const strengthLabel = this.uilib.createText({
      text: "笔刷强度",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.035,
    });
    strengthLabel.position.set(-1.0, this.height / 2 - 0.28, 0.001);
    this.container.add(strengthLabel);


    // 创建笔刷模式切换按钮（抬升/降低）
    const raiseModeBtn = this.uilib.createBtn({
      map: btn_normal,
      text: "抬升",
      textColor: 0xffffff,
      width: 0.4,
      height: 0.08,
      font: "bold",
      stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
    });
    raiseModeBtn.position.set(-0.75, this.height / 2 - 0.45, 0.001);
    this.container.add(raiseModeBtn);

    const lowerModeBtn = this.uilib.createBtn({
      map: btn_normal,
      text: "降低",
      width: 0.4,
      height: 0.08,
      textColor: 0xffffff,
      font: "bold",
      stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
    });
    lowerModeBtn.position.set(-0.3, this.height / 2 - 0.45, 0.001);
    this.container.add(lowerModeBtn);

    // 添加按钮事件
    raiseModeBtn.addClickEvent(() => {
      if (this.terrainBrush) {
        this.terrainBrush.setInvert(false);
        raiseModeBtn.setBgColor(0x44ff44);
        lowerModeBtn.setBgColor(0x666666);
      }
    });

    lowerModeBtn.addClickEvent(() => {
      if (this.terrainBrush) {
        this.terrainBrush.setInvert(true);
        lowerModeBtn.setBgColor(0xff4444);
        raiseModeBtn.setBgColor(0x666666);
      }
    });

    // 创建重置按钮
    const resetBtn = this.uilib.createBtn({
      map: btn_normal,
      text: "复原地形",
      width: 0.4,
      height: 0.08,
      textColor: 0xffffff,
      font: "bold",
      stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
    });
    resetBtn.position.set(-0.75, this.height / 2 - 0.6, 0.001);
    this.container.add(resetBtn);

    resetBtn.addClickEvent(() => {
      if (this.terrainBrush) {
        const restored = this.terrainBrush.resetTerrain();
        if (restored) {
          this.manager.vrManager.makeSystemTip("地形已复原");
        } else {
          this.manager.vrManager.makeSystemTip("没有可复原的地形");
        }
      }
    });

    // 创建使用说明
    const usageContainer = this.uilib.createContainer({
      width: 1.0,
      height: 0.5,
      radius: 0,
      dragable: false,
    });
    usageContainer.position.set(0.5, this.height / 2 - 0.35, 0.001);
    this.container.add(usageContainer);

    const usageTitle = this.uilib.createText({
      text: "使用说明:",
      textColor: 0xafbbe3,
      font: "bold",
      textSize: 0.05,
      align: "left"
    });
    usageTitle.position.set(-0.5, 0.2, 0.001);
    usageContainer.add(usageTitle);

    const spaceText1 = this.uilib.createText({
      text: " ",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    spaceText1.position.set(-0.5, 0.15, 0.001);
    usageContainer.add(spaceText1);

    const usageText1 = this.uilib.createText({
      text: "1. 选择地形模式后，控制器变为笔刷工具",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    usageText1.position.set(-0.5, 0.1, 0.001);
    usageContainer.add(usageText1);

    const spaceText2 = this.uilib.createText({
      text: " ",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    spaceText2.position.set(-0.5, 0.05, 0.001);
    usageContainer.add(spaceText2);
    
    const usageText2 = this.uilib.createText({
      text: "2. 按住扳机键拖拽可调整地形高度",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    usageText2.position.set(-0.5, 0.0, 0.001);
    usageContainer.add(usageText2);

    const spaceText3 = this.uilib.createText({
      text: " ",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    spaceText3.position.set(-0.5, -0.05, 0.001);
    usageContainer.add(spaceText3);


    const usageText3 = this.uilib.createText({
      text: "3. 调整笔刷半径和强度控制效果",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    usageText3.position.set(-0.5, -0.1, 0.001);
    usageContainer.add(usageText3);

    const spaceText4 = this.uilib.createText({
      text: " ",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    spaceText4.position.set(-0.5, -0.15, 0.001);
    usageContainer.add(spaceText4);

    const usageText4 = this.uilib.createText({
      text: "4. 选择抬升或下降方向",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.05,
      align: "left"
    });
    usageText4.position.set(-0.5, -0.2, 0.001);
    usageContainer.add(usageText4);
  }

  closePanel() {
    super.closePanel();
    
    // 禁用地形笔刷
    if (this.terrainBrush) {
      this.terrainBrush.disable();
    }

    // 清除指示器更新定时器
    if (this.indicatorUpdateIntervalId) {
      clearInterval(this.indicatorUpdateIntervalId);
      this.indicatorUpdateIntervalId = null;
    }

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }

  show() {
    super.show();

    // 初始化地形笔刷
    if (!this.terrainBrush) {
      this.terrainBrush = new TerrainBrush(this.manager);
    }
    
    // 启用地形笔刷
    this.terrainBrush.enable();

    this.activeController = this.manager.vrManager.getMainController();



    // 创建一个定时器，持续更新笔刷指示器位置
    this.indicatorUpdateIntervalId = setInterval(() => {
      //if (this._visible && !this.isModifying) {
      //if (!this.isModifying) {
        this.updateBrushIndicatorAtController();
      //}
    }, 100); // 每100ms更新一次指示器位置

    this.manager.interface.setClickMode(3); // 切换到地形编辑模式
  }

  /**
   * 处理VR控制器扳机键按下事件
   * @param {Object} controller VR控制器对象
   */
  onTriggerDown(controller) {
    //if (!this._visible || !this.terrainBrush) return;
    if (!this.terrainBrush) return;

    this.isModifying = true;
    // 开始修改地形
    this.startTerrainModification(controller);
  }

  /**
   * 处理VR控制器扳机键松开事件
   * @param {Object} controller VR控制器对象
   */
  onTriggerUp(controller) {
    //if (!this._visible || !this.terrainBrush) return;
    if (!this.terrainBrush) return;

    this.isModifying = false;
    
    // 停止修改地形
    this.stopTerrainModification();
  }

  /**
   * 开始修改地形
   * @param {Object} controller VR控制器对象
   */
  startTerrainModification(controller) {
    if (!this.terrainBrush || !controller) return;
    
    // 保存当前控制器
    this.activeController = controller;
    console.log("开始修改地形");

    // 创建一个定时器，持续修改地形
    //if (!this.modifyIntervalId) {
      this.modifyIntervalId = setInterval(() => {

        if (this.isModifying && this.activeController) {
          this.modifyTerrainAtController();
        }
      }, 100); // 每100ms修改一次地形
    //}
  }

  /**
   * 在控制器位置修改地形
   */
  modifyTerrainAtController() {
    if (!this.terrainBrush || !this.activeController) return;
    
    // 获取控制器射线与地形的交点
    const intersects = this.getControllerIntersections();
    
    if (intersects && intersects.length > 0) {
      // 在交点位置修改地形
      const hitPoint = intersects[0].point;
      const mesh = intersects[0].object;
      
      // 更新笔刷指示器位置
      this.terrainBrush.updateBrushIndicator(hitPoint);
      
      // 修改地形顶点
      this.terrainBrush.modifyVertices(mesh, hitPoint);
    } else {
      // 没有交点时隐藏笔刷指示器
      this.terrainBrush.hideBrushIndicator();
    }
  }

  /**
   * 更新控制器位置的笔刷指示器
   * 即使不修改地形，也会显示笔刷指示器
   */
  updateBrushIndicatorAtController() {
    if (!this.terrainBrush || !this.activeController) return;
    
    // 获取控制器射线与地形的交点
    const intersects = this.getControllerIntersections();
    
    if (intersects && intersects.length > 0) {
      // 在交点位置更新笔刷指示器
      const hitPoint = intersects[0].point;
      
      // 更新笔刷指示器位置
      this.terrainBrush.updateBrushIndicator(hitPoint);
    } else {
      // 没有交点时隐藏笔刷指示器
      this.terrainBrush.hideBrushIndicator();
    }
  }

  /**
   * 获取控制器射线与地形的交点
   * @returns {Array} 交点数组
   */
  getControllerIntersections() {
    if (!this.terrainBrush || !this.activeController) return null;
    
    // 更新地形网格列表
    if (this.terrainBrush.terrainMeshes.length === 0) {
      this.terrainBrush.updateTerrainMeshes();
      if (this.terrainBrush.terrainMeshes.length === 0) return null;
    }
    
    // 创建射线
    const raycaster = this.terrainBrush.raycaster;
    const tempMatrix = new Matrix4();
    
    // 设置射线起点和方向
    this.activeController.updateMatrixWorld();
    tempMatrix.identity().extractRotation(this.activeController.matrixWorld);
    raycaster.ray.origin.setFromMatrixPosition(this.activeController.matrixWorld);
    raycaster.ray.direction.set(0, 0, -1).applyMatrix4(tempMatrix);
    
    // 检测与地形的交点
    return raycaster.intersectObjects(this.terrainBrush.terrainMeshes, false);
  }

  /**
   * 停止修改地形
   */
  stopTerrainModification() {
    if (this.modifyIntervalId) {
      clearInterval(this.modifyIntervalId);
      this.modifyIntervalId = null;

    }
    
    //this.activeController = null;
  }

  /**
   * 清理资源
   */
  dispose() {
    this.stopTerrainModification();
    
    // 清除指示器更新定时器
    if (this.indicatorUpdateIntervalId) {
      clearInterval(this.indicatorUpdateIntervalId);
      this.indicatorUpdateIntervalId = null;
    }
    
    if (this.terrainBrush) {
      this.terrainBrush.dispose();
      this.terrainBrush = null;
    }
    
    super.dispose();
  }
}